import { render } from "./AppTitleBanner.vue?vue&type=template&id=2fd8879d&scoped=true"
import script from "./AppTitleBanner.vue?vue&type=script&lang=js"
export * from "./AppTitleBanner.vue?vue&type=script&lang=js"

import "./AppTitleBanner.vue?vue&type=style&index=0&id=2fd8879d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\pc\\Documents\\projets\\school_app_front_novation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd8879d"]])

export default __exports__